// import useMedia from '~/hooks/useMedia';
import Modal, { ModalBody } from 'components/common/modal';
// import BottomSheet from 'components/common/bottom-sheet';
import Container from 'components/common/container';
import OfflineForm from './offline-booking-form';
import useMedia from '~/hooks/useMedia';
import BottomSheet from '~/components/common/bottom-sheet';
type OfflineExperienceModalProps = {
   open: boolean;
   onClose: () => void;
   venue_id: string;
   name?: string;
   category?: string;
   city?: string;
   organizer?: string;
};

const OfflineExperienceModal = ({
   open,
   onClose,
   venue_id,
   name,
   category,
   city,
   organizer,
}: OfflineExperienceModalProps) => {
   const isMobile = useMedia(1100);

   return (
      <div>
         {isMobile ? (
            <BottomSheet open={open} toggle={onClose} showCloseButton>
               <Container>
                  <OfflineForm
                     venue_id={venue_id}
                     name={name}
                     category={category}
                     city={city}
                     organizer={organizer}
                     closeModal={onClose}
                  />
               </Container>
            </BottomSheet>
         ) : (
            <Modal open={open} size="xs" onClickOutside={onClose}>
               <ModalBody className="transition-all duration-150 ease-in-out ">
                  <div className="py-4">
                     <Container>
                        <OfflineForm
                           venue_id={venue_id}
                           name={name}
                           category={category}
                           city={city}
                           organizer={organizer}
                           closeModal={onClose}
                        />
                     </Container>
                  </div>
               </ModalBody>
            </Modal>
         )}
      </div>
   );
};
export default OfflineExperienceModal;
